import React, { useRef, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import "./styles/classificationLabel.css";
import ClassificationFilter from "./components/ClassificationFilter.jsx";
import ClassificationLeft from "./components/ClassificationLeft.jsx";
import ClassificationMiddle from "./components/ClassificationMiddle.jsx";
import ClassificationMiddleTop from "./components/ClassificationMiddleTop.jsx";
import ClassificationRight from "./components/ClassificationRight.jsx";
import useClassificationLabelHook from "./hooks/useClassificationLabelHook.js"
import useClassificationShortcuts from "./hooks/useClassificationShortcuts.js"
import VersionPopup from './components/VersionPopup.js'
import useClassificationStore from './store/useClassificationStore.js';
import useModelManagementStore from '../../modelManagement/store/useModelManagementStore';
import { modelIdOf } from '../../../../utils/labelingTarget';

const MODEL_STORAGE_KEY = 'lf-classification-model';
const VERSION_STORAGE_KEY = 'lf-classification-version-id';

const ClassificationLabel = () => {
  // const {isModalOpen,setIsModelOpen, setNewVersion}=useClassificationStore();
  const fileInputRef = useRef(null);
  const location = useLocation();
  const {handlers} = useClassificationLabelHook();
  const handlersRef = useRef(handlers);
  useEffect(() => {
    handlersRef.current = handlers;
  }, [handlers]);
  // 1-9 assign a class, arrows walk the queue — see useClassificationShortcuts
  useClassificationShortcuts(handlers);
  const { setModelInfo, modelInfo } = useModelManagementStore();
  const selectedModelFromState = location.state?.model;
  const versionIdFromState = location.state?.versionId;

  useEffect(() => {
    if (selectedModelFromState) {
      try {
        sessionStorage.setItem(MODEL_STORAGE_KEY, JSON.stringify(selectedModelFromState));
      } catch (err) {
        console.warn('Unable to persist classification model info', err);
      }
    }
    if (typeof versionIdFromState !== 'undefined') {
      try {
        if (versionIdFromState) {
          sessionStorage.setItem(VERSION_STORAGE_KEY, versionIdFromState);
        } else {
          sessionStorage.removeItem(VERSION_STORAGE_KEY);
        }
      } catch (err) {
        console.warn('Unable to persist classification version info', err);
      }
    }
  }, [selectedModelFromState, versionIdFromState]);

  const selectedModel = useMemo(() => {
    if (selectedModelFromState) return selectedModelFromState;
    try {
      const stored = sessionStorage.getItem(MODEL_STORAGE_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch (err) {
      console.warn('Unable to read stored classification model info', err);
      return null;
    }
  }, [selectedModelFromState]);

  const versionId = useMemo(() => {
    if (versionIdFromState) return versionIdFromState;
    try {
      const stored = sessionStorage.getItem(VERSION_STORAGE_KEY);
      return stored || null;
    } catch (err) {
      console.warn('Unable to read stored classification version info', err);
      return null;
    }
  }, [versionIdFromState]);

  const previousModelIdRef = useRef(null);

  useEffect(() => {
    if (
      selectedModel &&
      (!modelInfo || modelIdOf(selectedModel) !== modelIdOf(modelInfo))
    ) {
      setModelInfo(selectedModel);
    }

    // Either shape: a raw Mongo doc carries _id, a flattened one model_id.
    // Reading only model_id made every raw doc look like "no model" and
    // wiped the version that had just loaded.
    const currentId = modelIdOf(selectedModel);
    if (!currentId) {
      handlersRef.current.handleResetClsData();
      previousModelIdRef.current = null;
      return;
    }

    if (previousModelIdRef.current && previousModelIdRef.current !== currentId) {
      handlersRef.current.handleResetClsData();
    }
    previousModelIdRef.current = currentId;
  }, [modelInfo, selectedModel, setModelInfo]);

  useEffect(() => {
    if (versionId) {
      console.log("Editing model version ID:", versionId);
      const param={"model_info_id":versionId}
      handlersRef.current.handleGetOneClassificationData(param)
    }
    else{
      handlersRef.current.handleResetClsData();
    }
  }, [versionId]);

  // const handleCloseModal=()=>{
  //   setIsModelOpen(true);
  // }

  // const handleVersionUpdate=(value)=>{
  //     setNewVersion(value)
  // }

  return (
    <div className="container-fluid classification-label lf-fill-viewport">
      <div className="col-md-12 mt-2">
        <ClassificationFilter />
      </div>
      <div className="main-content">
        <div className="col-md-3 text-center left-col">
          <ClassificationLeft fileInputRef={fileInputRef} />
        </div>
        <div className="col-md-6 text-center center-col">
          <div className="content-top-classification">
            <ClassificationMiddleTop />
          </div>
          <div className="content-bottom-classification">
            <ClassificationMiddle />
          </div>
        </div>
        <div className="col-md-3 text-center right-col">
          <ClassificationRight fileInputRef={fileInputRef} />
        </div>
      </div>
      {/* <VersionPopup isModalOpen={isModalOpen} handleCloseModal={handleCloseModal} handleVersionUpdate={handleVersionUpdate}></VersionPopup> */}
    </div>
  );
};

export default ClassificationLabel;
